import React from 'react';
import PropTypes from 'prop-types';
import cloneDeep from 'lodash/cloneDeep';
import Storage from '../Storage/Storage';
import {FieldConnect, FormContext} from 'react-components-form';

export class TableObjectField extends React.Component {
    static contextType = FormContext;

    constructor(props) {
        super(props);
        this.state = {
            schema: {},
            model: props.value,
            validationErrors: {},
        };

        this.storage = new Storage(this.state.model);
        this.setModel = this.setModel.bind(this);
        this.getModel = this.getModel.bind(this);
        this.getSchema = this.getSchema.bind(this);
        this.getValidationErrors = this.getValidationErrors.bind(this);
        this.setStateModel = this.setStateModel.bind(this);
    }

    componentDidMount() {
        const { getSchema } = this.context;
        const schema = getSchema(this.props.name).type;
        this.setState({ schema });
        this.storage.listen(this.setStateModel);
    }

    UNSAFE_componentWillReceiveProps({ value }) {
        this.setState({ model: value });
        this.storage.setModel(value, null, true);
    }

    componentWillUnmount() {
        this.storage.unlisten(this.setStateModel);
    }

    setStateModel(model, callback) {
        this.props.onChange(cloneDeep(model));
        if (typeof callback === 'function') callback();
    }

    setModel(name, value, callback) {
        this.storage.set(name, value, callback);
    }

    getModel(name) {
        return this.state.model[name];
    }

    getSchema(name) {
        if (!this.state.schema) return {};
        if (Array.isArray(this.state.schema)) return this.state.schema[0].getField(name);
        if (typeof this.state.schema.getField === "function") return this.state.schema.getField(name);
    }

    getValidationErrors(name) {
        const { getValidationErrors } = this.context;
        const validationErrors = getValidationErrors(this.props.name);
        if (Array.isArray(validationErrors) && validationErrors.length === 1) {
            return validationErrors[0][name] || [];
        }
        return validationErrors[name] || [];
    }

    render() {
        const { children } = this.props;
        return (
            <FormContext.Provider value={{
                ...this.context,
                setModel: this.setModel,
                getModel: this.getModel,
                getSchema: this.getSchema,
                getValidationErrors: this.getValidationErrors,
            }}>
                {children}
            </FormContext.Provider>
        );
    }
}

TableObjectField.propTypes = {
    value: PropTypes.shape({}),
    name: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    children: PropTypes.node,
    wrapperClassName: PropTypes.string,
    fieldAttributes: PropTypes.shape({}),
};

TableObjectField.defaultProps = {
    value: {},
    name: undefined,
    children: '',
    wrapperClassName: '',
    fieldAttributes: {},
};

export default FieldConnect(TableObjectField);
